export default __webpack_public_path__ + "static/media/zabala3_c.3906029a.jpg";